import ReactDom from "react-dom";
import Annotation from "./Annotation.jsx";

export default function renderAnnotations() {
  document.querySelectorAll(".js-annotation-mount").forEach((mount) => {
    const data = JSON.parse(mount.getAttribute("data-annotation"));

    // Get marker information
    const markerType = mount.getAttribute("data-marker-type");
    const markerPositionTop = parseInt(
      mount.getAttribute("data-marker-position-top"),
    );
    const markerPositionRight = parseInt(
      mount.getAttribute("data-marker-position-right"),
    );
    const markerNoColor = mount.getAttribute("data-marker-no-color");
    const hasNoColor = markerNoColor ? true : false;

    ReactDom.render(
      <Annotation
        markerType={markerType}
        markerPositionTop={markerPositionTop}
        markerPositionRight={markerPositionRight}
        markerNoColor={hasNoColor}
        {...data}
      />,
      mount,
    );
  });
}
